import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, forkJoin, Observable, Subject } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { UserService } from './user.service';
import { Text } from '@angular/compiler';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'multipart/form-data'
  })
};


const httpOptions1 = {
  headers: new HttpHeaders({
    'Accept': 'text/html',
    'Content-Type': 'application/json'
  }),
  responseType: 'text'
};

const headers2 = {
  responseType: 'text'
}

@Injectable({
  providedIn: 'root'
})


export class AuthService {

  constructor(private http: HttpClient, private api: UserService) { }



  login1(body: any): Observable<any> {


    return this.api.post2(`${environment.apiBaseUrl}` + '/User/Login', body, { responseType: 'text' });


  }

  getOptionList(): Observable<any> {

    return this.api.post2(`${environment.apiBaseUrl}` + '/Master/getAccounts', null, { responseType: 'text' });
  }

  GetCategoryList(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrl}` + '/Master/getCategories', null, { responseType: 'text' });
  }

  getproductlistbyid(body: any): Observable<any> {

    return this.api.post2(`${environment.apiBaseUrl}` + '/Master/getProductDetails', body, { responseType: 'text' });
  }

  addMoneyRequestupi(body: any): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/Promo/addMoney', body, { responseType: 'text' });
  }

  purchasedByPromoRequest(body: any): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/Promo/purchasedByPromo', body, { responseType: 'text' });
  }

  changePassword(body: any): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/User/ChangePassword', body, { responseType: 'text' });


  }

  getIsdCodeSignup(): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/Master/getCountries', null, { responseType: 'text' });
  }


  
  signup(body: any): Observable<any> {

    return this.api.post2(`${environment.apiBaseUrl}` + '/User/Signup', body, { responseType: 'text' });
  }


  forgetPasswordVerifyCode(body: any): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/User/ForgetPasswordOTP', body, { responseType: 'text' });

  }

  forgetPassword(body: any): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/User/ForgetPassword', body, { responseType: 'text' });

  
  }

  //UPIresponseapi
  UPIresponseapi(body: any): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/Promo/getPromoCode', body, { responseType: 'text' });

  }



  getUserOrdersdetails(body: any): Observable<any> {
    
    return this.api.post2(`${environment.apiBaseUrl}` + '/Promo/transactionList', body, { responseType: 'text' });
  }

  getPromoList(body: any): Observable<any> {

    return this.api.post2(`${environment.apiBaseUrl}` + '/Promo/getPromoList', body, { responseType: 'text' });
  }

  getProductByPrice(body: any): Observable<any> {
    return this.api.post2(`${environment.apiBaseUrl}` + '/Master/getCategoriesByPrice', body, { responseType: 'text' });

  }


  ////////////////


  getValidateeziPaycountryToken(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrl}` + '/Login/eziPay/Login');
  }

  changeMobileNoBeforeVerified(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/ezipay/user/Updatemobile', body);

  }

  changeEmailIdBeforeVerified(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/ezipay/user/UpdateEmail', body);
  }


  //Otp
  sendOtp(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/ezipay/MobileVerify/OTP', body);
  }


  verifyOtp(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/ezipay/VerifyOTP', body);
  }

  //kyc
  UpdateDocumentUploadStatus(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/api/eziPay/Kyc', body);
  }

  //Kyc
  uploadFile(formdata: FormData): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/Kyc', formdata).pipe(map(response => {
      return response;
    }, httpOptions));

  }

  KYClist(kycid: any): Observable<any> {
    const params = new HttpParams()
      .set('kycid', kycid);

    return this.api.get(`${environment.apiBaseUrl}` + '/Master/KYCType').pipe(map(response => {
      return response;
    }));
  }

  KYCUserDetails(Username: any): Observable<any> {
    const params = new HttpParams()
      .set('Username', Username);

    return this.api.get(`${environment.apiBaseUrl}` + '/Master/KYCUserDetails');;
  }


  

  ChangeFirstLastName(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/ChangeFirstLastName', body).pipe(map(response => {
      return response;
    }));
  }

  UploadProfileImage(formdata: FormData): Observable<any> {

    return this.api.post(`${environment.apiBaseUrl}` + '/Login/UploadProfileImage', formdata).pipe(map(response => {
      return response;
    }, httpOptions));
  }




  getServiceCountryList(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrl}` + '/Master/eziPayGlobal/Servicecountry');
  }

  getFaq(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Banner/faq');
  }
  //signup country api change 
  getIsdCode(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrl}` + '/Master/eziPayAfrica/country');
  }


  getOtpIsdCode(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrl}` + '/Master/eziPayAfrica/otpcountry');
  }


  getUserdetails(body: any): Observable<any> {

    return this.api.post(`${environment.apiBaseUrl}` + '/Login/refreshwelcomeEzipay', body);
  }


  //get token
  Continuebtnsettoken(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/v1/welcomeEzipay', body);

  }




  getchannelList(code: any, serviceid: any): Observable<any> {

    const params = new HttpParams()
      .set('code', code);
    return this.api.post(`${environment.apiBaseUrl}` + '/Master/getAccountServices?code=AGV', null);
  }

  getVoucherList(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrl}` + '/Master/getVouchers');
  }


  getMerchantList(serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.get(url + '/Home/getmerchant');
  }
  //submit momo  same url use for every option request

  payMobileMoney(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/eziPay/services/pay-mmo', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }
  //submit momo  same url use for every option request
  payairForm(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/eziPay/services/airtime', body).pipe(map(response => {
      return response;
    }));

  }

  getServiceCommissionList(Amountrequested: any, SelectedrblOptionCode: any, SelectedNetworkCode: any, serviceid: any, ): Observable<any> {

    // var body = { Amount: Amountrequested, AddService_Code: SelectedrblOptionCode, PayService_Code: SelectedNetworkCode };
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    const params = new HttpParams()
      .set('Amount', Amountrequested)
      .set('AddService_Code', SelectedrblOptionCode)
      .set('PayService_Code', SelectedNetworkCode);
    return this.api.get(url + '/ezipay/Commission').pipe(map(response => {
      return response;
    }));
  }


  getUserdetailsbytoken(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrl}` + '/Master/GetUserDetail').pipe(map(response => {
      return response;
    }));
  }

  getUserdetailsCurrBal(serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.get(url + '/UserAccountManage/UserBalance').pipe(map(response => {
      return response;
    }));
  }

  getdthcountryList(serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }


    return this.api.get(url + '/eziPay/DTHcountries').pipe(map(response => {
      return response;
    }));
  }

  getdthServicesList(countryid: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    const params = new HttpParams()
      .set('countryid', countryid);
    return this.api.get(url + '/eziPay/DTHservices').pipe(map(response => {
      return response;
    }));
  }
  getdthOperatorList(country_id: any, service_id: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    const params = new HttpParams()
      .set('country_id', country_id)
      .set('service_id', service_id);
    return this.api.get(url + '/ezipay/DTHoperators').pipe(map(response => {
      return response;
    }));
  }
  getdthProductsList(productId: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    const params = new HttpParams()
      .set('productId', productId);
    return this.api.get(url + '/ezipay/DTHProductList').pipe(map(response => {
      return response;
    }));
  }

  //submit DTH  same url use for every option request
  payDTH(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/eziPay/services/International/Gift-voucher', body).pipe(map(response => {
      return response;
    }));

  }

  //int. mobile rechasrge
  getIntMobProductsList(IsdCode: any, mobileno: any, ServiceCode: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    const params = new HttpParams()
      .set('IsdCode', IsdCode)
      .set('mobileno', mobileno)
      .set('AccountCode', ServiceCode);
    return this.api.get(url + '/ezipay/MobileVoucherList').pipe(map(response => {
      return response;
    }));
  }

  //submit int. mobile rechasrge same url use for every option request
  payIntMob(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.post(url + '/eziPay/services/International/Top-up', body).pipe(map(response => {
      return response;
    }));

  }

  //user use which service
  getUserOrdersdetailsByUserId(ezipayReferenceid: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    const params = new HttpParams()
      .set('ezipayReferenceid', ezipayReferenceid);

    return this.api.get(url + '/Orders/Ordersdetails').pipe(map(response => {
      return response;
    }));
  }



  

  getUserOrdersdetails1(AccountCode: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    const params = new HttpParams()
      .set('AccountCode', AccountCode);

    return this.api.get(url + '/Orders/Orders').pipe(map(response => {
      return response;
    }));
  }

  GetCountCurrentWebNotification(Userid: any, countryid: any, roleid: any): Observable<any> {
    //var body = { "Userid": Number(this.currentUser.Userdetailid), "countryid": Number(this.currentUser.serviceid), "roleid": 2 }

    const params = new HttpParams()
      .set('Userid', Userid)
      .set('countryid', countryid)
      .set('roleid', roleid);
    return this.api.get(`${environment.apiBaseUrl}` + '/Notification/GetCountCurrentWebNotification').pipe(map(response => {
      return response;
    }));
  }

  UpdateCurrentWebNotification(body: any): Observable<any> {

    return this.api.post(`${environment.apiBaseUrl}` + '/Notification/UpdateCurrentWebNotification', body).pipe(map(response => {
      return response;
    }));

  }

  GetCurrentWebNotificationList(countryid: any, roleid: any): Observable<any> {
    const params = new HttpParams()

      .set('countryid', countryid)
      .set('roleid', roleid);
    return this.api.get(`${environment.apiBaseUrl}` + '/Notification/GetCurrentWebNotificationList').pipe(map(response => {
      return response;
    }));
  }
  //submit walletservice
  generateQrCode(serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.get(url + '/eziPay/services/get-QRCode').pipe(map(response => {
      return response;
    }));

  }
  //submit int. mobile rechasrge same url use for every option request
  viewTransactionsRequest(serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.get(url + '/eziPay/services/view-paymentreq').pipe(map(response => {
      return response;
    }));

  }

  makepaymentRequestaccept(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.post(url + '/eziPay/services/payment-accept', body).pipe(map(response => {
      return response;
    }));

  }

  makepaymentRequestfail(ezipayRefid: any, serviceid: any): Observable<any> {

    const params = new HttpParams()
      .set('ezipayRefid', ezipayRefid);

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.post(url + '/Orders/ViewPaymentReq-failed', null).pipe(map(response => {
      return response;
    }));

  }
  //
  payMoney(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.post(url + '/ThirdPartyGamingMerchant/add-money', body).pipe(map(response => {
      return response;
    }));

  }

  //
  makePaymentRequest(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.post('https://testnew.ezipay.global/merchant/payment-req', body).pipe(map(response => {
      return response;
    }));

    //return this.api.post(url + '/eziPay/services/payment-req', body).pipe(map(response => {
    //  return response;
    //}));

  }

  //
  addMoneyRequest(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.post(url + '/eziPay/add-money', body).pipe(map(response => {
      return response;
    }));

  }
  //
  addMoneyRequestTransfertobank(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }
    return this.api.post(url + '/eziPay/add-money-flluterbanktransfer', body).pipe(map(response => {
      return response;
    }));

  }
  //
  addMobileMoneyRequest(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/eziPay/add-mmo', body).pipe(map(response => {
      return response;
    }));

  }

  addMobileMoneyRequestuploadcardImage(formdata: FormData): Observable<any> {


    return this.api.post(`${environment.apiBaseUrl}` + '/PaymentCards/card-upload', formdata).pipe(map(response => {
      return response;
    }, httpOptions));

  }


  getcardnoList(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrl}` + '/PaymentCards/Cardslist').pipe(map(response => {
      return response;
    }));

  }

  getSubjectList(serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.get(url + '/ContactUs/contactussubjectlist').pipe(map(response => {
      return response;
    }));

  }

  saveFeedBackContact(body: any, serviceid: any): Observable<any> {

    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/ContactUs/insert-contactus', body).pipe(map(response => {
      return response;
    }));

  }
  //merchant
  merchantOnBoardRequest(body: any): Observable<any> {

    return this.api.post(`${environment.apiBaseUrl}` + '/Home/MerchantSignup', body);
  }

  merchantuploadFile(formdata: FormData): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/MerchantDoc', formdata).pipe(map(response => {
      return response;
    }, httpOptions));

  }

  XBetpay(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrlsl}` + '/eziPay/services/pay-XBet', body).pipe(map(response => {
      return response;
    }));

  }

  getxbetaccountdetail(accountNO: any): Observable<any> {

    const params = new HttpParams()
      .set('accountNO', accountNO);
    return this.api.get(`${environment.apiBaseUrlsl}` + '/eziPay/Xbet-accountExit').pipe(map(response => {
      return response;
    }));
  }


  getFile(route: string, params?: any): any {
    return this.http.post(route, params, {
      responseType: 'blob' as 'json'
    });
  }

  report(body: any): Observable<any> {

    return this.getFile('https://newapi.ezipaysl.com/api/PaymentRequestController/TransactionStatement', body)
  }

  

  //Flutter
  FlutterSubmitBankresponseapi(status: any, tx_ref: any, transaction_id: any): Observable<any> {
    const params = new HttpParams()
      .set('status', status)
      .set('tx_ref', tx_ref)
      .set('transaction_id', transaction_id);
    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/eziPay/flutter-response').pipe(map(response => {
      return response;
    }));
  }

  GetBeneficiaryType(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Home/GetBeneficiary-Type').pipe(map(response => {
      return response;
    }));
  }

  GetBeneficiaryRelationship(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Home/GetBeneficiary-Relationship').pipe(map(response => {
      return response;
    }));
  }

  GetkycType(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Home/GetkycType').pipe(map(response => {
      return response;
    }));
  }

  GetMobileMoneyBeneficiaryDetails(country_code: any): Observable<any> {
    const params = new HttpParams()
      .set('beneficiary_country_Accountcode', country_code);

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/BeneficiaryDetails/GetBeneficiaryDetails').pipe(map(response => {
      return response;
    }));
  }


  submitMobileMoneyBeneficiary(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/BeneficiaryDetails/BeneficiaryDetails', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }

  GetMobileMoneyBeneficiaryDetailsbyId(id: any): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/BeneficiaryDetails/GetBeneficiaryDetails?id=' + id).pipe(map(response => {
      return response;
    }));
  }

  GetBeneficiaryRelationshipList(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Home/GetBeneficiary-Relationshipother').pipe(map(response => {
      return response;
    }));

  }

  // TransferToBank
  GetbankDetails(country_code: any): Observable<any> {
    const params = new HttpParams()
      .set('AccountCode', country_code);

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/global-banklist').pipe(map(response => {
      return response;
    }));
  }

  //submit momo  same url use for every option request

  payTransferToBank(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/eziPay/services/pay-TTB', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }




  editIdmobileMoneyBeneficiary(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/BeneficiaryDetails/update-BeneficiaryDetails', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }

  submitbanktransferBeneficiary(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/BeneficiaryDetails/tob-BeneficiaryDetails', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }

  GetbanktransferBeneficiaryDetailsbyId(id: any): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/BeneficiaryDetails/tob-GetBeneficiaryDetails?id=' + id).pipe(map(response => {
      return response;
    }));
  }

  editIdbanktransferBeneficiary(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/BeneficiaryDetails/update-tobBeneficiaryDetails', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }

  GetbanktransferBeneficiaryDetails(country_code: any): Observable<any> {
    const params = new HttpParams()
      .set('beneficiary_country_Accountcode', country_code);

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/BeneficiaryDetails/tob-GetBeneficiaryDetails').pipe(map(response => {
      return response;
    }));
  }


  //submit banktransfer 

  paytransfertoBank(body: any, serviceid: any): Observable<any> {
    var url = "";
    if (serviceid == 3) {
      url = `${environment.apiBaseUrlsl}`
    }
    else if (serviceid == 7) {
      url = `${environment.apiBaseUrlGlobal}`
    }

    return this.api.post(url + '/eziPay/services/pay-transfertoBank', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }

  getsenderOccupationlistLN(): Observable<any> {

    const params = new HttpParams()
      .set('cattype', 'OCC');

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/global-benficarylist').pipe(map(response => {
      return response;
    }));
  }

  getsenderSourceOfFundlistLN(): Observable<any> {

    const params = new HttpParams()
      .set('cattype', 'SOF');

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/global-benficarylist').pipe(map(response => {
      return response;
    }));
  }

  getpurposeofremittancelistLN(): Observable<any> {

    const params = new HttpParams()
      .set('cattype', 'POR');

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/global-benficarylist').pipe(map(response => {
      return response;
    }));
  }

  getsenderreceiveridtypelistLN(): Observable<any> {

    const params = new HttpParams()
      .set('cattype', 'DOC');

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/global-benficarylist').pipe(map(response => {
      return response;
    }));
  }

  getstatsenderreceiveridtypelistLN(): Observable<any> {

    const params = new HttpParams()
      .set('cattype', 'STA');

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/global-benficarylist').pipe(map(response => {
      return response;
    }));
  }

  downloadTransactionLogs(body: any): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Orders/download-usertransactionHistory').pipe(map(response => {

      return response;
    }));
  }


  reportpdf(body: any): Observable<any> {

    var url = `${environment.apiBaseUrlGlobal}`

    return this.api.get(url + '/Orders/Orders-download').pipe(map(response => {
      return response;
    }));

  }


  getbranchcodebangladeshLN(bankentryid: any): Observable<any> {

    const params = new HttpParams()
      .set('bankentryid', bankentryid);

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/global-branchcode').pipe(map(response => {
      return response;
    }));
  }


  addMoneymerchantonlineRequest(body: any): Observable<any> {

    return this.api.post(`${environment.apiBaseUrlGlobalMerchant}` + '/merchant/process-addmoney', body).pipe(map(response => {
      return response;
    }));

  }



  getMerchantapi(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrl}` + '/Master/merchant-apikey').pipe(map(response => {
      return response;
    }));
  }


  addmerchantstore(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Merchant/insert-merchantstore', body).pipe(map(response => {
      return response;
    }));
  }


  getmerchantstorelist(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrl}` + '/Merchant/get-merchantstore').pipe(map(response => {
      return response;
    }));
  }

  Paymerchant(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrlGlobal}` + '/eziPay/services/Merchant-goods-Services', body).pipe(map(response => {
      return response;
    }));
  }

  gettokenmerchantplugin(userid: any): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobalMerchant}` + '/merchant/get-token?userid=' + userid).pipe(map(response => {
      return response;
    }));
  }

  GetCookie(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Cookies/get-cookie').pipe(map(response => {
      return response;
    }));
  }

  postCookie(): Observable<any> {

    //return this.api.post(`${environment.apiBaseUrlGlobal}` + '/Cookies/post-cookie', null, { observe: 'response' }).pipe(map(response => {

    //  return response;
    //}));
    return this.http.get(`${environment.apiBaseUrlGlobal}` + '/Cookies/token').pipe(map(response => {
      //logic to extract cookie from result
      return response;
    }));


  }
  LoginWithGoogle(): Observable<any> {
    //const header = new HttpHeaders().set('Content-type', 'application/json');
    return this.http.post(`${environment.apiBaseUrlGlobal}` + "/Cookies/cookie", null);
  }



  BeneficiaryInfoDELETEbyId(editId: any): Observable<any> {
    var body =
    {
      id: editId
    }

    return this.api.post(`${environment.apiBaseUrlGlobal}` + '/BeneficiaryDetails/disable-tobBeneficiaryDetails', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }

  BeneficiaryInfoDELETEbyIdmobilemone(editId: any): Observable<any> {
    var body =
    {
      id: editId
    }

    return this.api.post(`${environment.apiBaseUrlGlobal}` + '/BeneficiaryDetails/disable-BeneficiaryDetails', body).pipe(map(response => {
      return response;
    }, httpOptions1));

  }


  getcompanyname(): Observable<any> {

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/Home/Gettransactionlimit').pipe(map(response => {
      return response;
    }));
  }

  UpdatereferencialCode(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Login/update-referentialcode', body).pipe(map(response => {
      return response;
    }));
  }


  checkpasswordviewpayment(body: any): Observable<any> {

    return this.api.post(`${environment.apiBaseUrlGlobal}` + '/eziPay/services/user-valid', body);

  }


  //int. country api 
  GetdtoneCountryList(): Observable<any> {
    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/ezipay/GetdtoneCountryList').pipe(map(response => {
      return response;
    }));
  }

  GetdtoneoperatorsList(country_iso_code: any): Observable<any> {
    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/ezipay/GetdtoneOperatorList?country_iso_code=' + country_iso_code).pipe(map(response => {
      return response;
    }));
  }

  GetdtoneproductsList(operator_id: any): Observable<any> {
    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/ezipay/GetdtoneproductsList?operator_id=' + operator_id).pipe(map(response => {
      return response;
    }));
  }


  //KoraBankSubmitBankresponseapi
  KoraBankSubmitBankresponseapi(status: any, tx_ref: any, transaction_id: any): Observable<any> {
    const params = new HttpParams()
      .set('status', status)
      .set('tx_ref', tx_ref)
      .set('transaction_id', transaction_id);
    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/eziPay/kora-response').pipe(map(response => {
      return response;
    }));
  }




  // korapaybanklist :- get https://testnew.ezipay.global/api/TransferToBank/get-korapaybanklist?AccountCode=KNT
  GetkorapaybanklistDetails(): Observable<any> {
    const params = new HttpParams()
      .set('AccountCode', 'KNT');

    return this.api.get(`${environment.apiBaseUrlGlobal}` + '/TransferToBank/get-korapaybanklist').pipe(map(response => {
      return response;
    }));
  }


  Resendemailid(body: any): Observable<any> {
    return this.api.post(`${environment.apiBaseUrl}` + '/Home/emailverifylink', body).pipe(map(response => {
      return response;
    }));
  }


  




}
